import { useSyncExternalStore } from "react";
import { embeddedAccessTokenProvider } from "../embedded-token-provider";

const subscribe = (listener: () => void) => embeddedAccessTokenProvider.subscribe(listener);
const getSnapshot = () => embeddedAccessTokenProvider.getSnapshot();

/** 当前内存中的交换 Token。只用于判断"有没有凭证"，不要把它传给任何组件。 */
export function useHasEmbeddedAccessToken(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot) !== null;
}
